import { createFileRoute } from "@tanstack/react-router";

import { loadNamespaces } from "../../app/i18n";
import { OwnerShell } from "../../areas/owner/shell/OwnerShell";
import { guard } from "../../shared/auth/guards";
import { OwnerNotFound } from "../../shared/layout/NotFound";
import { RouteError } from "../../shared/layout/RouteError";

/** Owner portal layout: guard `owner`, then the simple owner shell. */
export const Route = createFileRoute("/portal/_owner")({
  beforeLoad: async (args) => {
    await Promise.all([guard("owner", args), loadNamespaces("owner")]);
  },
  component: OwnerShell,
  errorComponent: RouteError,
  notFoundComponent: OwnerNotFound,
});
